import {gql, useLazyQuery} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getNotificationBanner($locale: String!){
	notificationBannerCollection(limit: 1, where: { slug_exists: false },locale: $locale) {
		items{
			notificationType
			visibleTo
			visibleFrom
			bannerIcon{
				title
				url
			}
			bannerTitle
			bannerSubtitle
			ctaLinksCollection{
				items{
					...on Button{
						type
						label
                        contentPage {
							slug
						}
						url
					}
				}
			}
		    openCtaInNewTab
			hasCloseButton
			visibleForUserRoles
			userCountryCollection {
                items {
                    ... on Country {
                        countryCode
                    }
                }
            }
            excludeFromRoutes
			dialogIcon{
				url
				title
			}
			dialogText{
				json
			}
		}
	}
}
`;

export const useNotificationBanner = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const [getNotificationBanner, {loading, data, error}] = useLazyQuery(QUERY, {
        variables: { locale: localeUppercase},
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"});
    const notificationBannerDetails = data?.notificationBannerCollection?.items?.[0];

    if(error?.message) {
        logger(error?.message, "error", "useNotificationBanner", error?.stack);
    }

    return {
        getNotificationBanner,
        notificationBannerDetails,
        loading,
        error
    };
};
